export function setLoadingIndicator(element: HTMLFormElement): void {
    const submitBtn: Element | null = getSubmitButton(element);
    submitBtn?.classList.add('btn--loading');
    submitBtn?.setAttribute('disabled', 'disabled');
}

export function removeLoadingIndicator(element: HTMLFormElement): void {
    const submitBtn: Element | null = getSubmitButton(element);
    submitBtn?.classList.remove('btn--loading');
    submitBtn?.removeAttribute('disabled');
}

function getSubmitButton(element: HTMLFormElement): Element | null {
    return element.querySelector('button[type=submit]') || element.querySelector('input[type=submit]');
}
